const pivotOptions = [
  { label: "Venue", value: "VENUE" },
  { label: "Pitcher", value: "PITCHER" },
  { label: "Catcher", value: "CATCHER" },
  { label: "Batter", value: "BATTER" }
];

export default pivotOptions;



// WEBPACK FOOTER //
// ./src/constants/pivotOptions.js